import {useEffect, useRef, useState} from "react";
import {useDrag} from "react-use-gesture";

const _MIN_PROJECT_WIDTH = 250;
const _MIN_TERMINAL_HEIGHT = 200;

const useCodeEditorLayout = () => {
  const [editorAppHeight, setEditorAppHeight] = useState(0);
  const [projectAreaWidth, setProjectAreaWidth] = useState(_MIN_PROJECT_WIDTH);
  const [terminalAreaHeight, setTerminalAreaHeight] = useState(_MIN_TERMINAL_HEIGHT);
  const [editorMainHeight, setEditorMainHeight] = useState(0);
  const [codeAreaHeight, setCodeAreaHeight] = useState(0);

  const editorApp = useRef();
  const editorMainRef = useRef();
  const horizontalBarRef = useRef();
  const toolbarRef = useRef();

  // 初始化各个区域的高度
  useEffect(() => {
    setTimeout(() => {
      const containerHeight = editorApp.current.parentNode.offsetHeight;
      setEditorAppHeight(containerHeight);
      setEditorMainHeight(containerHeight - _MIN_TERMINAL_HEIGHT - horizontalBarRef.current.offsetHeight - toolbarRef.current.offsetHeight);
    }, 0);
  }, []);

  // 计算编辑框高度
  useEffect(() => {
    setCodeAreaHeight(editorMainHeight - 30);
  }, [editorMainHeight]);

  // 左侧滑动
  const bindVerticalDrag = useDrag(({ delta }) => {
    let width = projectAreaWidth + delta[0];
    if (width <= _MIN_PROJECT_WIDTH) {
      width = _MIN_PROJECT_WIDTH;
    }
    setProjectAreaWidth(width);
  });

  // 右侧滑动
  const bindHorizontalDrag = useDrag(({ delta }) => {
    let height = terminalAreaHeight - delta[1];
    if (height <= _MIN_TERMINAL_HEIGHT) {
      height = _MIN_TERMINAL_HEIGHT;
    }
    setTerminalAreaHeight(height);
    const containerHeight = editorApp.current.parentNode.offsetHeight;
    setEditorMainHeight(containerHeight - height - horizontalBarRef.current.offsetHeight - toolbarRef.current.offsetHeight);
  });

  return {
    editorMainHeight,
    projectAreaWidth,
    terminalAreaHeight,
    editorAppHeight,
    codeAreaHeight,
    editorApp,
    editorMainRef,
    horizontalBarRef,
    toolbarRef,
    bindHorizontalDrag,
    bindVerticalDrag
  };
};

export default useCodeEditorLayout;
